export default __webpack_public_path__ + "static/media/actions_purple.8a7044d2.svg";